import { render, staticRenderFns } from "./PlatonFormAdminFooter.vue?vue&type=template&id=47322bb5"
import script from "./PlatonFormAdminFooter.vue?vue&type=script&lang=js"
export * from "./PlatonFormAdminFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports